import ManufacturerHeaderSection from "./ManufacturerHeaderSection";
import ManufacturerListComponent from "./ManufacturerListComponent";

const ManufacturerSetupComponent = () => {
  return (
    <>
      <ManufacturerHeaderSection />
      <ManufacturerListComponent />
    </>
  );
};

export default ManufacturerSetupComponent;
